import React from 'react'
import { IoIosClose } from "react-icons/io";
import { IoIosAdd } from "react-icons/io";
import { IoIosCheckmark } from "react-icons/io";
import { IoMdCreate } from "react-icons/io";

function Strength() {

    const handleEdit = () => {

    }
    return (
        <div className="box2 mb-4">
            <div className="box-header">
                <h4 className='subtitle-font'>strengths</h4>
                <IoMdCreate
                    onClick={handleEdit}
                    style={{
                        fontSize: '20px',
                        cursor: 'pointer',
                    }}
                />
            </div>
           
        </div>
    )
}

export default Strength